module.exports = __webpack_public_path__ + "static/media/youtube.548cc4d0.png";